import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f2fbd87&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2fbd87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2fbd87')) {
      api.createRecord('3f2fbd87', component.options)
    } else {
      api.reload('3f2fbd87', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3f2fbd87&scoped=true&", function () {
      api.rerender('3f2fbd87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/article/active/index.vue"
export default component.exports